import api from './client';

export type UserProfile = {
  id?: string;
  email?: string;
  name?: string;
  role?: string;
  [k: string]: any;
};

export async function getProfile(): Promise<UserProfile | null> {
  try {
    console.log('[services/getProfile] fetching /v1/auth/me');
    const { data } = await api.get('/v1/auth/me');
    if (!data) return null;
    const payload = (data && (data.data || data)) as any;
    const profile: UserProfile = {
      id: payload.UniqueId ?? payload.id ?? payload.userId ?? payload.user?.id,
      email: payload.email ?? payload.user?.email ?? payload.userEmail,
      name: payload.NameOfUser ?? payload.name ?? payload.user?.name ?? payload.userName,
      role: payload.Role ?? payload.role ?? payload.user?.role,
      ...payload,
    };
    return profile;
  } catch (err: any) {
    console.error('[services/getProfile] error', err?.response?.data ?? err?.message ?? err);
    throw err;
  }
}

export default { getProfile };
